<template>
  <div>
    <template v-for="(item, index) in data">
      <dl
        :key="index"
        @click="jumpDetail(item)"
        :clstag="`newscenter|keycount|detail-H5|link-id-${item.id}`"
        v-if="index < length"
      >
        <dt v-if="item.appHeader != ''">
          <img v-lazy="item.appHeader" alt />
        </dt>
        <dd>
          <h3 :class="item.appHeader == '' ? 'noImgStyle' : ''">
            <img
              v-if="item.pubTime >= todyTimer"
              src="@/assets/img-m/icon-new.png"
            />
            <span
              v-html="item.title"
              :class="item.isMark ? 'font-red' : ''"
            ></span>
            <!-- <i class="top" v-if="item.top"></i> -->
          </h3>
        </dd>
      </dl>
    </template>
  </div>
</template>

<script>
import jumpDetail from '../mixin/jumpDetail'
export default {
  mixins: [jumpDetail],
  todyTimer: '',
  props: {
    data: Array,
    length: {
      //显示条数，默认最大值
      type: Number,
      default: Number.MAX_VALUE
    }
  },
  beforeMount() {
    this.todyTimer = new Date().setHours(0, 0, 0, 0) //当前日时间戳
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
dl {
  width: 100%;
  margin: 0 auto;
  display: flex;
  display: -webkit-flex;
  border-bottom: 1px solid #f5f5f5;
  dt {
    width: 2.24rem;
    height: 1.5rem;
    margin: 0.3rem 0.2rem 0.3rem 0;
    background: #fcfafa url('../.././../assets/img-m/set-img.png') no-repeat
      center;
    background-size: 1.2rem;
    img {
      display: block;
      border-radius: 0.1rem;
      overflow: hidden;
      width: 2.24rem;
      height: 1.5rem;
    }
  }
  dd {
    padding: 0.25rem 0.1rem 0.25rem 0;
    h3 {
      @include ellipsisMultiline($number: 3);
      font-size: 0.32rem;
      color: #333;
      line-height: 0.52rem;
      flex: 1;
      -webkit-flex: 1;
      min-height: 1rem;
      &.noImgStyle {
        @include ellipsisMultiline($number: 2);
      }
      img {
        width: 0.7rem;
        margin-right: 0.1rem;
        vertical-align: middle;
      }
    }
  }
  .font-red {
    color: #e02020 !important;
  }
}
</style>
